import React, { useState } from 'react';
import { upsertLead } from '../lib/firebase';

const CATEGORIES = [
  'Gym / Fitness', 'Physio / Allied Health', 'Clinic / GP',
  'Tradie / Builder', 'Consultant', 'Legal', 'Accounting',
  'Dental', 'Chiro / Osteo', 'Salon / Beauty', 'Other',
];

export default function AddLead() {
  const [form, setForm] = useState({
    businessName: '', contactName: '', category: '',
    phone: '', email: '', website: '',
    address: '', suburb: '', notes: '',
    status: 'new',
  });
  const [result, setResult] = useState(null);
  const [saving, setSaving] = useState(false);

  function set(field) {
    return e => setForm(f => ({ ...f, [field]: e.target.value }));
  }

  async function handleSubmit() {
    if (!form.businessName.trim()) { setResult({ type: 'err', msg: 'business name is required.' }); return; }
    setSaving(true);
    try {
      const { action } = await upsertLead({ ...form, source: 'manual' });
      setResult({
        type: 'ok',
        msg: action === 'created'
          ? `created — ${form.businessName}`
          : action === 'merged'
          ? `merged new info into ${form.businessName}`
          : `already exists with same data — no changes made`,
      });
      if (action === 'created') {
        setForm({ businessName: '', contactName: '', category: '', phone: '', email: '', website: '', address: '', suburb: '', notes: '', status: 'new' });
      }
    } catch (e) {
      setResult({ type: 'err', msg: e.message });
    }
    setSaving(false);
  }

  return (
    <div>
      <div className="page-header">
        <div className="page-eyebrow">▸ contacts / new</div>
        <div className="page-title">add lead</div>
        <div className="page-divider" />
      </div>

      <div className="form-section">
        <div className="form-section-title">business</div>
        <div className="form-grid">
          <div className="form-field">
            <label>business name *</label>
            <input value={form.businessName} onChange={set('businessName')} placeholder="e.g. Sydney Physio Group" />
          </div>
          <div className="form-field">
            <label>contact name</label>
            <input value={form.contactName} onChange={set('contactName')} placeholder="e.g. James Nguyen" />
          </div>
          <div className="form-field">
            <label>category</label>
            <select value={form.category} onChange={set('category')}>
              <option value="">— select —</option>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="form-section">
        <div className="form-section-title">contact</div>
        <div className="form-grid">
          <div className="form-field">
            <label>phone</label>
            <input value={form.phone} onChange={set('phone')} placeholder="02 9000 0000" />
          </div>
          <div className="form-field">
            <label>email</label>
            <input value={form.email} onChange={set('email')} type="email" placeholder="hello@business.com" />
          </div>
          <div className="form-field">
            <label>website</label>
            <input value={form.website} onChange={set('website')} placeholder="https://" />
          </div>
        </div>
      </div>

      <div className="form-section">
        <div className="form-section-title">location</div>
        <div className="form-grid">
          <div className="form-field">
            <label>address</label>
            <input value={form.address} onChange={set('address')} placeholder="123 George St" />
          </div>
          <div className="form-field">
            <label>suburb</label>
            <input value={form.suburb} onChange={set('suburb')} placeholder="Surry Hills" />
          </div>
          <div className="form-field">
            <label>status</label>
            <select value={form.status} onChange={set('status')}>
              {['new', 'contacted', 'qualified', 'closed', 'cold'].map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="form-section">
        <div className="form-section-title">notes</div>
        <div className="form-field" style={{ border: 'none', padding: '0' }}>
          <label>notes</label>
          <textarea value={form.notes} onChange={set('notes')} placeholder="any context about this lead..." />
        </div>
      </div>

      {result && (
        <div className={`import-result import-${result.type}`}>{result.msg}</div>
      )}

      <div className="form-actions">
        <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
          {saving ? 'saving...' : 'save ▸'}
        </button>
      </div>
    </div>
  );
}
